<app-mat-spinner-overlay
  *ngIf="showWaitingForDataSpinner == true"
  [overlay]="true"
>
</app-mat-spinner-overlay>

<div class="spacer"></div>
<div class="container container-border container-size">
  <h2>{{anwendungsname}}</h2>
</div>

<div class="spacer"></div>
<div class="container container-border container-size">
  <div class="row">
    <div class="col-md-12">
      <mat-tab-group
        mat-align-tabs="start"
        dynamicHeight="true"
        animationDuration="0ms"
      >
        <mat-tab label="Tierwohlindikatoren" class="tab-reiter">
          <div class="c-tab container-border">
            <div class="row"></div>
            <div class="row">
              <div class="col-md-12">
                <p>
                  Wenn Sie möchten, können Sie die Zahl der auf der nächsten
                  Seite angezeigten
                  <span class="sumFilter">{{ sumFilter }}</span>
                  <fa-icon
                  [icon]="faInfoCircle"
                  class="mx-1 icon-info"
                  matTooltip="In der Datenbank sind ca. 2.500 Indikatoren enthalten Viele Indikatoren gelten jedoch gleichzeitig für mehrere Tierarten oder Nutzungsrichtungen, sodass insgesamt mehr als 5000 Indikatoren angezeigt werden können"
                  matTooltipPosition="right"
                  >info</fa-icon>                                    
                  Indikatoren aus
                  der Literatur nun eingrenzen:
                  
                </p>

              </div>
            </div>
            <div class="spacer"></div>
            <div class="row">
              <div class="col-md-12">
                <mat-accordion class="example-headers-align" multi>
                  <mat-expansion-panel
                    [expanded]="indikatorenGeoffnet"
                    (opened)="setIndikatorenOpened()"
                    (closed)="setIndikatorenClosed()"
                  >
                    <mat-expansion-panel-header>
                      <mat-panel-title class="width-title">
                        Tierart
                      </mat-panel-title>
                      <mat-panel-description
                        *ngIf="indikatorenGeoffnet == false"
                      >
                        Hier klicken zum Ausklappen
                      </mat-panel-description>
                      <mat-panel-description
                        *ngIf="indikatorenGeoffnet == true"
                      >
                        Hier klicken zum Einklappen</mat-panel-description
                      >
                    </mat-expansion-panel-header>
                    <div class="row">
                      <ng-container *ngFor="let ind of indikatoren">
                        <ng-container *ngIf="ind.indikatorTyp == 1">
                          <ul class="col-md-3">
                            <mat-checkbox
                              class="checkbox-label"
                              [checked]="ind.checked"
                              [indeterminate]="ind.indeterminate"
                              color="primary"
                              (change)="
                                setAll($event.checked, ind.idIndikator, false)
                              "
                            >
                              <span class="auswahl_ueberschrift">{{
                                ind.indikator
                              }}</span>
                              <fa-icon
                                [icon]="faInfoCircle"
                                class="mx-1 icon-info"
                                *ngIf="ind.tooltip != null"
                                matTooltip='{{ ind.tooltip }}'
                                matTooltipPosition="right"
                                >info</fa-icon
                              >                              
                            </mat-checkbox>

                            <div *ngIf="ind.subIndikatoren != null">
                              <ul>
                                <li
                                  *ngFor="
                                    let subIndikator of ind.subIndikatoren
                                  "
                                >
                                  <mat-checkbox
                                    class="checkbox-label"
                                    [checked]="subIndikator.checked"
                                    (change)="
                                      setCheck(
                                        $event.checked,
                                        ind.idIndikator,
                                        subIndikator.idIndikator,
                                        false,
                                        true
                                      )
                                    "
                                  >
                                    {{ subIndikator.indikator }}
                                  </mat-checkbox>
                                </li>
                              </ul>
                            </div>
                          </ul>
                        </ng-container>
                      </ng-container>
                    </div>
                  </mat-expansion-panel>

                  <mat-expansion-panel
                    [expanded]="adbGeoffnet"
                    (opened)="setADBOpened()"
                    (closed)="setADBClosed()"
                  >
                    <mat-expansion-panel-header>
                      <mat-panel-title class="width-title">
                        Abschnitt, Dimension, Bezug
                      </mat-panel-title>
                      <mat-panel-description *ngIf="adbGeoffnet == false">
                        Hier klicken zum Ausklappen
                      </mat-panel-description>
                      <mat-panel-description *ngIf="adbGeoffnet == true">
                        Hier klicken zum Einklappen</mat-panel-description
                      >
                    </mat-expansion-panel-header>
                    <div class="row">
                      <ng-container *ngFor="let ind of indikatoren">
                        <ng-container
                          *ngIf="
                            ind.indikatorTyp == 2 ||
                            ind.indikatorTyp == 3 ||
                            ind.indikatorTyp == 4
                          "
                        >
                          <ul class="col-md-3">
                            <div class="auswahl_ueberschrift_adb">
                              <span class="auswahl_ueberschrift">{{
                                ind.indikator
                              }}</span>
                              <fa-icon
                                [icon]="faInfoCircle"
                                class="mx-1 icon-info"
                                *ngIf="ind.tooltip != null"
                                matTooltip='{{ ind.tooltip }}'
                                matTooltipPosition="right"
                                >info</fa-icon
                              >                              
                            </div>
                            <div *ngIf="ind.subIndikatoren != null">
                              <ul>
                                <li
                                  *ngFor="
                                    let subIndikator of ind.subIndikatoren
                                  "
                                >
                                  <mat-checkbox
                                    class="checkbox-label"
                                    [checked]="subIndikator.checked"
                                    (change)="
                                      setCheck(
                                        $event.checked,
                                        ind.idIndikator,
                                        subIndikator.idIndikator,
                                        false,
                                        true
                                      )
                                    "
                                  >
                                    {{ subIndikator.indikator }}
                                  </mat-checkbox>
                                </li>
                              </ul>
                            </div>
                          </ul>
                        </ng-container>
                      </ng-container>
                    </div>
                  </mat-expansion-panel>

                  <mat-expansion-panel
                    [expanded]="ueberkategorienGeoffnet"
                    (opened)="setUeberkategorienOpened()"
                    (closed)="setUeberkategorienClosed()"
                  >
                    <mat-expansion-panel-header>
                      <mat-panel-title class="width-title"
                        >Themenbereiche</mat-panel-title
                      >
                      <mat-panel-description
                        *ngIf="ueberkategorienGeoffnet == false"
                      >
                        Hier klicken zum Ausklappen
                      </mat-panel-description>
                      <mat-panel-description
                        *ngIf="ueberkategorienGeoffnet == true"
                      >
                        Hier klicken zum Einklappen</mat-panel-description
                      >
                    </mat-expansion-panel-header>
                    <div class="row">
                      <div
                        *ngFor="let entry of ueberkategorieFilter"
                        class="col-md-6"
                      >
                        <mat-checkbox
                          class="checkbox-label"
                          [checked]="entry.checked"
                          color="primary"
                          (change)="
                            setCheckFilter(
                              entry.idUeberkategorie,
                              $event.checked
                            )
                          "
                          [disabled]="entry.anzahl === 0"
                        >
                          {{ entry.ueberkategorie }} | ({{ entry.anzahl }})
                          <fa-icon
                            [icon]="faInfoCircle"
                            class="mx-1 icon-info"
                            *ngIf="entry.info != null"
                            [matTooltip]="entry.info"
                            matTooltipPosition="right"
                            >info</fa-icon
                          >
                        </mat-checkbox>
                      </div>
                    </div>
                  </mat-expansion-panel>
                </mat-accordion>
              </div>
            </div>
            <div class="spacer"></div>
            <div class="row">
              <div class="col-md-12">
                <mat-card>
                  <div class="row">
                    <div class="col-md-12 text-right">
                      <button
                        (click)="sendTierwohlIndikatoren()"
                        mat-raised-button
                        color="primary"
                        class="custom-btn"
                        type="button"
                      >
                        Weiter
                        <fa-icon
                          [icon]="faArrowRight"
                          class="mx-1 icon-arrow"
                        ></fa-icon>
                      </button>
                    </div>
                  </div>
                </mat-card>
              </div>
            </div>
          </div>
        </mat-tab>

        <mat-tab label="Tierwohl-Begleitindikatoren">
          <div class="c-tab container-border">
            <div class="row"></div>
            <div class="row">
              <div class="col-md-12">
                <p>
                  Wenn Sie möchten, können Sie die Zahl der auf der nächsten
                  Seite angezeigten
                  <span class="sumFilter">{{
                    sumFilterBegleitindikatoren
                  }}</span>
                  Indikatoren aus der Literatur nun eingrenzen:
                </p>
              </div>
            </div>
            <div class="spacer"></div>
            <div class="row">
              <div class="col-md-12">
                <mat-accordion class="example-headers-align" multi>
                  <mat-expansion-panel [expanded]="true" disabled="true">
                    <div class="spacer"></div>
                    <div class="row">
                      <ng-container *ngFor="let ind of indikatoren">
                        <ng-container *ngIf="ind.indikatorTyp == 5">
                          <ul class="col-md-12">
                            <mat-checkbox
                              class="checkbox-label"
                              [checked]="ind.checked"
                              [indeterminate]="ind.indeterminate"
                              color="primary"
                              (change)="
                                setAll($event.checked, ind.idIndikator, true)
                              "
                            >
                              <span class="auswahl_ueberschrift">{{
                                ind.indikator
                              }}</span>
                            </mat-checkbox>

                            <div *ngIf="ind.subIndikatoren != null">
                              <ul>
                                <li
                                  *ngFor="
                                    let subIndikator of ind.subIndikatoren
                                  "
                                >
                                  <mat-checkbox
                                    class="checkbox-label"
                                    [checked]="subIndikator.checked"
                                    (change)="
                                      setCheck(
                                        $event.checked,
                                        ind.idIndikator,
                                        subIndikator.idIndikator,
                                        true,
                                        true
                                      )
                                    "
                                  >
                                    {{ subIndikator.indikator }}
                                  </mat-checkbox>
                                </li>
                              </ul>
                            </div>
                          </ul>
                        </ng-container>
                      </ng-container>
                    </div>
                  </mat-expansion-panel>

                  <div class="row">
                    <div class="col-md-12">
                      <mat-card>
                        <div class="row">
                          <div class="col-md-12 text-right">
                            <button
                              (click)="sendBegleitIndikator()"
                              mat-raised-button
                              color="primary"
                              class="custom-btn"
                              type="button"
                            >
                              Weiter  
                            </button>
                          </div>
                        </div>
                      </mat-card>
                    </div>
                  </div>
                </mat-accordion>
              </div>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</div>

<div class="spacer"></div>